module.exports = __webpack_public_path__ + "media/images/flags/64/Martinique-d1e1565d9788847b54ddc4494009d806.png";